import $ from 'jquery'

export default {
    name: 'assure-actes',
    components: {},
    props: {
        list_exclu_actes: Array
    },
    data() {
        return {
            all_checked: false,
            one_is_checked: [],
			each_cat_is_checked: [],
            text_grey: []
        }
    },

    watch: {
        one_is_checked() {
            this.$store.commit('SET_EXCLU_ACTE', this.one_is_checked)
        }
    },

    computed: {
        tarif_actes() {
            return this.$store.getters["tarif_actes"];
        },
    },

    mounted() {
        this.listeActes()
    },

    methods: {
        listeActes() {
            this.$store.dispatch('getTarifActes', 'acte').then(() => {
                if (this.tarif_actes.length > 0) {
                    this.setSelectedActes()
                } 
            })
        },

        setSelectedActes() {
			this.one_is_checked = []
            this.text_grey = []

            this.list_exclu_actes.forEach(exclusion => {
                this.tarif_actes.forEach(acte => {
					if (exclusion.id == acte.id) {
                        this.text_grey[acte.id] = 'text-grey'
                        this.one_is_checked.push(acte.id)
                    } 
                });
            });
		},

        toutSelectionner() {
            let is_checked = $('#all-acte').is(":checked")
            this.toggleAllChecked(is_checked)
        },

        toggleAllChecked(is_checked) {
            this.one_is_checked = []
            this.each_cat_is_checked = []
            
            this.tarif_actes.forEach((acte) => {
                if (is_checked) {
                    this.one_is_checked.push(acte.id)
                }
                this.text_grey[acte.id] = (is_checked)?'text-grey':''
            });
            
            this.all_checked = is_checked
        },

        onExclu(index) {
            let is_checked = $('#acte'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c
        },
    }
}